import { Controller } from "stimulus";

// Drives the Mesa white-label login screen:
//  - show/hide password
//  - re-roll the devotional verse from the shipped pool (fade, no reload)
//  - submit loading state
export default class extends Controller {
  static targets = ["password", "eye", "verse", "ref", "reflect", "theme", "submit"];
  static values = { verses: Array, index: Number };

  connect() {
    // Clear dismissed portal messages so they show again on the next login/logout.
    try {
      window.localStorage.removeItem("portal-messages-dismissed");
    } catch (e) {
      // Ignore storage errors (private mode / quota).
    }
  }

  togglePassword() {
    const input = this.passwordTarget;
    const show = input.type === "password";
    input.type = show ? "text" : "password";
    if (this.hasEyeTarget) this.eyeTarget.classList.toggle("is-on", show);
  }

  reroll() {
    if (!this.hasVersesValue || this.versesValue.length < 2) return;

    let next = this.indexValue;
    while (next === this.indexValue) {
      next = Math.floor(Math.random() * this.versesValue.length);
    }
    this.indexValue = next;

    const verse = this.versesValue[next];
    this.fade(() => {
      if (this.hasThemeTarget) this.themeTarget.textContent = verse.theme;
      if (this.hasVerseTarget) this.verseTarget.textContent = verse.text;
      if (this.hasRefTarget) this.refTarget.textContent = verse.ref;
      if (this.hasReflectTarget) this.reflectTarget.textContent = verse.reflect;
    });
  }

  fade(swap) {
    const nodes = [this.verseTarget, this.reflectTarget].filter((n) => n);
    nodes.forEach((n) => n.classList.add("lg-fade"));
    setTimeout(() => {
      swap();
      nodes.forEach((n) => n.classList.remove("lg-fade"));
    }, 300);
  }

  submitting() {
    if (!this.hasSubmitTarget) return;
    this.submitTarget.classList.add("is-loading");
    this.submitTarget.disabled = true;
  }
}
